export default angular.module("QoipApp",
    [
        "KhBase",
        "highcharts-ng",
        "leaflet-directive",
    ]
);
